"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function DestaquesGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="224894" className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[340px] animate-pulse rounded-xl bg-muted/30" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-sm text-muted-foreground font-default">
        Unable to load our fresh bakes at the moment.
      </div>;
  }
  if (products.length === 0) {
    return <div className="py-12 text-center text-sm text-muted-foreground font-default">
        No featured treats found today.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
      {products.map((product, i) => <Card key={product.id} data-index={i} className="group flex flex-col overflow-hidden border-none bg-background pt-0 shadow-sm transition-all duration-300 hover:shadow-xl">
          <Link to={product.link} className="relative aspect-square overflow-hidden bg-muted/10 rounded-full m-4">
            {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted/20">
                <span className="text-xs text-muted-foreground font-default">Baking...</span>
              </div>}
          </Link>
          <CardContent className="flex flex-grow flex-col justify-between gap-4 p-4 text-center">
            <div className="space-y-1.5">
              <Link to={product.link}>
                <h3 className="font-default line-clamp-2 text-base font-semibold leading-tight text-foreground transition-colors hover:text-primary">
                  {product.title}
                </h3>
              </Link>
              <div className="font-serif text-xl font-bold text-primary">
                ${product.price?.toFixed(2) || "0.00"}
              </div>
            </div>
            <div className="mt-auto pt-2">
              <AddToCartButton productId={product.id} variant="default" size="sm" className="w-full" buttonClassName="w-10 h-10 mx-auto rounded-full bg-primary text-primary-foreground shadow-md hover:bg-primary/90 hover:scale-105 transition-transform flex items-center justify-center" text="+" showQuantity={false} />
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
const wp_query_params = {
  per_page: 4,
  orderby: "date",
  order: "desc"
};
const wp_query = new WP_Query(wp_query_params);
export default function DestaquesDaSemana() {
  return <section id="the-daily-batch" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex items-end justify-between gap-4 border-b border-border pb-6">
          <div className="space-y-2">
            <h2 className="font-serif text-4xl font-bold tracking-tight text-foreground md:text-5xl">
              The Daily Batch
            </h2>
            <p className="text-base text-muted-foreground font-default max-w-md">
              Hand-crafted artisan favorites, pulled fresh from the oven this morning.
            </p>
          </div>
          <Link to="#" className="hidden text-sm font-medium tracking-wider uppercase text-primary hover:text-primary/80 transition-colors sm:block">
            View Full Bakery &rarr;
          </Link>
        </div>
        
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc"
      }}>
          <DestaquesGridConsumer />
        </EcommerceProductsProvider>

        <div className="mt-12 flex justify-center sm:hidden">
          <Link to="#" className="text-sm font-medium text-primary hover:underline font-default">
            Explore all products &rarr;
          </Link>
        </div>
      </div>
    </section>;
}